import {
  getTeamOrganization,
  getProjectMembers,
  getTeamMembers,
  getGroupMembers,
  emailIsRegister,
  inviteNewMember,
  getSearchUsersDatas,
  getEnableMembers,
  getTeamSetLeaderDatas,
  getTeamSetPermissionList,
  saveTeamSetPermissionList
} from '@/services/team'
import _ from 'lodash'
export default {
  namespaced: true,
  state: {
    isOtherRole: false,
    isOtherGroup: false,
    permmissionLists: {}, // 权限列表
    inviteNewMemberVisible: false, // 邀请新成员panel状态
    editLeaderDialog: false, // 编辑主管dialog
    treeUserSearch: [], // 组织结构用户搜索
    teamSetSaveLoading: false, // 团队设置保存loading
    teamItemName: '', // 树选中泪目名称
    teamItemCount: 0, // 成员列表数量
    roleId: null, // 已选择的角色Id
    editLeaderLoading: false, // 编辑主管保存losding
    loadingVision: true, // 加载动画
    projectMembers: [], // 项目成员列表
    teamSetPermissionList: [], // 团队设置权限列表
    teamSetLeaderList: [], // 团队设置头部信息
    teamSetList: [], // 团队设置头部信息
    selectTreenDataId: null, // 左侧已选中树数据Id
    selectTreenDataKey: null, // 左侧已选中树数据Key
    treeDatas: [], // 左侧树列表数据
    treeDefaultKey: [], // 默认选中树key值
    tableDatas: [], // 成员列表Table数据
    teamSetVisible: false, // 团队设置状态
    inviteIsregList: null, // 邀请成员注册状态列表
    groupMembersDetail: {},
    isFilter: false
  },
  mutations: {
    setLoadingVision (state, data) {
      state.loadingVision = data
    },
    setTeamSetSaveLoading (state, data) {
      state.teamSetSaveLoading = data
    },
    setInviteIsregList (state, data) {
      state.inviteIsregList = data
    },
    setProjectMembers (state, data) {
      state.projectMembers = data
    },
    setPermmissionLists (state, data) {
      state.permmissionLists = data
    },
    setEditLeaderLoading (state, data) {
      state.editLeaderLoading = data
    },
    setEditLeaderDialog (state, data) {
      state.editLeaderDialog = data
    },
    // 设置组织结构treeData数据
    setTreeDatas (state, data) {
      state.treeDatas = data
    },
    // 设置组织结构treeData数据
    setTableDatas (state, data) {
      state.tableDatas = data
    },
    // 设置组织结构treeData数据
    setInviteMemberVisible (state, data) {
      state.inviteNewMemberVisible = data
    },
    // 设置左侧树默认key值
    setTreeDefaultKey (state, data) {
      state.treeDefaultKey = data
    },
    // 设置所选类目名称
    setTeamItemName (state, data) {
      state.teamItemName = data
    },
    // 设置成员列表数量
    setTeamItemCount (state, data) {
      state.teamItemCount = data
    },
    // 设置左侧树ID
    setSelectTreenDataId (state, data) {
      state.selectTreenDataId = data
    },
    // 设置左侧树Key
    setSelectTreenDataKey (state, data) {
      state.selectTreenDataKey = data
    },
    // 设置角色ID
    setRoleId (state, data) {
      state.roleId = data
    },
    // 设置团队设置状态
    setTeamSetVisible (state, data) {
      state.teamSetVisible = data
    },
    // 设置用户搜索
    setTreeUserSearch (state, data) {
      state.treeUserSearch = data
    },
    // 设置团队设置头部信息
    setTeamSetLeaderList (state, data) {
      if (data.flag === 0) {
        state.teamSetLeaderList = data.data
      } else {
        state.teamSetList = data.data
      }
    },
    // 设置团队设置权限列表
    setTeamSetPermissionList (state, data) {
      state.teamSetPermissionList = data
    },
    setIsOtherRole (state, data) {
      state.isOtherRole = data
    },
    setIsOtherGroup (state, data) {
      state.isOtherGroup = data
    },
    setGroupMembersDetail (state, data) {
      state.groupMembersDetail = data
    },
    setFilterStatus (state, b) {
      state.isFilter = b
    }
  },
  actions: {
    changeEditLeaderLoading ({ commit }, data) {
      commit('setEditLeaderLoading', data)
    },
    changeTeamSetSaveLoading ({ commit }, data) {
      commit('setTeamSetSaveLoading', data)
    },
    changeEditLeaderDialog ({ commit }, type) {
      commit('setEditLeaderDialog', type)
    },
    // 改变邀请页状态方法
    changInviteMemberVisible ({ commit, dispatch }, data) {
      commit('setInviteMemberVisible', data)
      dispatch('team/member/fetchGetRoles', { status: 1 }, { root: true })
    },
    // 改变邀请页Loading状态方法
    changeTreeDefaultKey ({ commit }, data) {
      commit('setTreeDefaultKey', data)
    },
    // 改变团队设置状态
    changeTeamSetVisible ({ commit }, data) {
      commit('setTeamSetVisible', data)
    },
    changeTreeKeyName ({ commit }, data) {
      commit('setTeamItemName', data.name)
      commit('setSelectTreenDataKey', data.key)
    },
    // 获取人员列表
    getMembersBySelectId ({ commit, dispatch }, data) {
      const [keyStr] = data.key
      commit('setSelectTreenDataKey', keyStr)
      commit('setTeamItemName', data.name)
      if (!keyStr) return
      if (keyStr.indexOf('|') >= 0) {
        const groupArr = _.split(keyStr, '|')[1]
        const groupId = groupArr.split('-')[1]
        dispatch('fetchGroupMemberDatas', groupId)
      } else {
        commit('setGroupMembersDetail', {})
        const array = _.split(keyStr, '-')
        const [keyName, Id] = array
        switch (keyName) {
          case 'projectid':
            dispatch('fetchProjectMemberDatas')
            break
          case 'roleid':
            // commit('setIsOtherRole', false)
            dispatch('fetchTeamMemberDatas', Id)
            commit('setIsOtherRole', true)
            break
          default:
            break
        }
      }
    },
    // 获取团队管理组织结构方法
    async fetchTeamOrganizationDatas ({ commit, dispatch }, data) {
      const chain = await getTeamOrganization()
        .onNetSuccess(raw => {
          if (raw.data.error === 0) {
            if (raw.data.permissions) {
              commit('setPermmissionLists', raw.data.permissions)
            }
            const payload = raw.data.payload
            if (data) {
              if (data.name) {
                commit('setTeamItemName', data.name)
              } else if (data.roleid) {
              } else {
                commit('setTeamItemName', payload.name)
              }
            }
            if (Array.isArray(payload)) {
              if (data) {
                if (data.name) {
                  commit('setTreeDefaultKey', new Array(`${data.name}-${data.groupid}`))
                  dispatch('formateLowRoleTreeDatas', {
                    payload,
                    groupid: data.groupid
                  })
                } else if (data.roleid) {
                  commit('setTreeDefaultKey', new Array(`${data.roleName}-${data.roleid}`))
                  dispatch('formateLowRoleTreeDatas', {
                    payload,
                    roleid: data.roleid
                  })
                } else {
                  commit('setTreeDefaultKey', new Array(`${payload[0].keyname}-${payload[0].id}`))
                  commit('setTeamItemName', payload[0].name)
                  dispatch('formateLowRoleTreeDatas', { payload })
                }
              } else {
                commit('setTreeDefaultKey', new Array(`${payload[0].keyname}-${payload[0].id}`))
                commit('setTeamItemName', payload[0].name)
                dispatch('formateLowRoleTreeDatas', { payload })
              }
            } else {
              let name = ''
              if (data) {
                if (data.name) {
                  commit('setTreeDefaultKey', new Array(`${data.name}-${data.groupid}`))
                  dispatch('formateTreeDatas', {
                    payload,
                    groupid: data.groupid
                  })
                } else if (data.roleid) {
                  commit('setTreeDefaultKey', new Array(`${data.roleName}-${data.roleid}`))
                  dispatch('formateTreeDatas', {
                    payload,
                    roleid: data.roleid
                  })
                } else {
                  commit('setTreeDefaultKey', new Array(`${payload.keyname}-${payload.id}`))
                  if (payload.name.length >= 10) {
                    name = payload.name.substr(0, 9) + '···'
                  } else {
                    name = payload.name
                  }
                  commit('setTeamItemName', name)
                  dispatch('formateTreeDatas', { payload })
                }
              } else {
                commit('setTreeDefaultKey', new Array(`${payload.keyname}-${payload.id}`))
                if (payload.name.length >= 10) {
                  name = payload.name.substr(0, 9) + '···'
                } else {
                  name = payload.name
                }
                commit('setTeamItemName', name)
                dispatch('formateTreeDatas', { payload })
              }
            }
          }
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 格式化TreeDatas
    formateLowRoleTreeDatas ({ commit, dispatch }, datas) {
      let data = datas.payload
      let treeLists = []
      let defaultExtend = []
      let methods = ''
      _.forEach(data, value => {
        const groupArray = {
          title: value.name,
          key: `${data[0].keyname}-${data[0].id}`,
          slots: { icon: 'treeNodeIcon' },
          children: []
        }
        if (value.children) {
          defaultExtend.push(`${data[0].keyname}-${data[0].id}`)
        }
        _.forEach(value.children, values => {
          groupArray.children.push({
            title: values.name,
            slots: { icon: 'treeNodeIcon' },
            key: `${data[0].keyname}-${data[0].id}|${values.keyname}-${values.id}`
          })
        })
        treeLists.push(groupArray)
      })
      commit('setTreeDatas', treeLists)
      if (datas.groupid) {
        methods = 'fetchGroupMemberDatas'
        dispatch(methods, datas.groupid)
      } else if (datas.roleid) {
        methods = 'fetchTeamMemberDatas'
        dispatch(methods, datas.roleid)
      } else {
        if (data[0].keyname === 'roleid') {
          methods = 'fetchTeamMemberDatas'
        } else {
          methods = 'fetchGroupMemberDatas'
        }
        dispatch(methods, data[0].id)
      }
    },
    // 格式化TreeDatas
    formateTreeDatas ({ commit, dispatch }, datas) {
      let data = datas.payload
      let defaultExtend = []
      let name = ''
      if (data.name.length >= 10) {
        name = data.name.substr(0, 9) + '···'
      } else {
        name = data.name
      }
      const projectList = {
        title: name,
        key: `${data.keyname}-${data.id}`,
        slots: { icon: 'parentTreeNodeIcon' },
        children: []
      }
      defaultExtend.push(`${data.keyname}-${data.id}`)
      _.forEach(data.children, value => {
        const groupArray = {
          title: value.name,
          key: `${value.keyname}-${value.id}`,
          type: '2',
          slots: { icon: 'treeNodeIcon' },
          children: []
        }
        defaultExtend.push(`${value.keyname}-${value.id}`)
        _.forEach(value.children, values => {
          groupArray.children.push({
            title: values.name,
            slots: { icon: 'treeNodeIcon' },
            key: `${value.keyname}-${value.id}|${values.keyname}-${values.id}`
          })
        })
        projectList.children.push(groupArray)
      })
      commit('setTreeDatas', new Array(projectList))
      if (datas.groupid) {
        dispatch('fetchGroupMemberDatas', datas.groupid)
      } else if (datas.roleid) {
        dispatch('fetchTeamMemberDatas', datas.roleid)
      } else {
        dispatch('fetchProjectMemberDatas')
      }
    },
    // 获取项目下成员列表方法
    async fetchProjectMemberDatas ({ commit }, roleid) {
      const chain = await getProjectMembers()
        .params(roleid)
        .onSuccess(payload => {
          commit('setTeamItemCount', payload.count)
          commit('setProjectMembers', payload.list)
          commit('setTableDatas', payload.list)
          commit('setLoadingVision', false)
          commit('setFilterStatus', roleid && Object.keys(roleid).length > 0)
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取团队下成员列表方法
    async fetchTeamMemberDatas ({ commit }, roleid) {
      const chain = await getTeamMembers()
        .onSuccess((raw, res) => {
          const { error, payload } = res
          if (error === 0) {
            commit('setTeamItemCount', payload.count)
            commit('setTableDatas', payload.list)
            commit('setLoadingVision', false)
          }
        })
        .params({
          roleid
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取小组下成员列表方法
    async fetchGroupMemberDatas ({ commit }, groupid) {
      const chain = await getGroupMembers()
        .onSuccess((raw, res) => {
          const { error, payload } = res
          if (error === 0) {
            commit('setGroupMembersDetail', payload)
            commit('setTeamItemCount', payload.member.count)
            commit('setTableDatas', payload.member.list)
            commit('setLoadingVision', false)
          }
        })
        .params({
          groupid
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },

    // 邀请新成员判断是否被注册过
    async fetchEmailIsRegister ({ commit }, params) {
      const chain = await emailIsRegister()
        .onNetSuccess(raw => {
          commit('setInviteIsregList', {
            email: params.email,
            isreg: raw.data.payload.isreg,
            truename: raw.data.payload.truename
          })
        })
        .params({
          email: params.email
        })
        .config({
          tip: true
        })
      return chain
    },
    // 邀请新成员方法
    async fetchInviteMemberDatas ({ commit }, params) {
      const chain = await inviteNewMember()
        .onSuccess(payload => {
          // console.log(payload)
        })
        .params({
          inviteinfo: params
        })
        .config({
          tip: true
        })
        .fetch()
      return chain
    },
    // 搜索用户
    async fetchSearchUsersDatas ({ commit }, params) {
      const chain = await getSearchUsersDatas()
        .onSuccess(payload => {
          commit('setTreeUserSearch', payload.list)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取主管团队设置
    async fetchGetTeamSetLeaderDatas ({ commit }, params) {
      const chain = await getEnableMembers()
        .onSuccess(payload => {
          if (params.leadertype) {
            commit('setTeamSetLeaderList', { data: payload.list, flag: 0 })
          } else {
            commit('setTeamSetLeaderList', { data: payload.list, flag: 1 })
          }
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 保存主管团队设置
    async fetchSaveTeamSetLeaderDatas ({ commit, dispatch }, params) {
      const chain = await getTeamSetLeaderDatas()
        .onSuccess(payload => {
          commit('setTeamSetVisible', false)
          commit('setTeamSetSaveLoading', false)
          dispatch('fetchGetTeamSetLeaderDatas', {
            roleid: params.roleid,
            leadertype: 'team'
          })
        })
        .params({
          ...params
        })
        .config({
          tip: true
        })
      await chain.fetch()
      return chain
    },
    // 团队设置权限列表
    async fetchGetTeamSetPermissionList ({ commit }, params) {
      const chain = await getTeamSetPermissionList()
        .onSuccess(payload => {
          commit('setTeamSetPermissionList', payload)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 团队设置权限列表保存
    async fetchSaveTeamSetPermissionList ({ commit }, params) {
      commit('setTeamSetSaveLoading', true)
      const chain = await saveTeamSetPermissionList()
        .onSuccess(payload => {
          commit('setTeamSetSaveLoading', false)
          commit('setTeamSetVisible', false)
        })
        .params({
          ...params
        })
        .config({
          tip: true
        })
        .fetch()
      return chain
    }
  }
}
